export default "__VITE_ASSET__BdH3WJnN__"